import urlJoin from 'url-join';
import get from 'lodash.get';
import configStorage from '../configuration/config-storage';
import yoproductsServiceClient from '../common/helpers/yoproducts-service-client';

const generatePaymentUrl = (paymentParams, isB2C = true) => {
  const { commonConfig } = configStorage.get();
  const yoproducts = yoproductsServiceClient.get();

  const checkoutserviceUrl = get(commonConfig, `checkoutservice.${isB2C ? 'url' : 'wl_url'}`, '');

  const initiatePaymentUrl = yoproducts.actions.makePaymentUrl(paymentParams);

  return urlJoin(checkoutserviceUrl, initiatePaymentUrl);
};

export default generatePaymentUrl;
